import Layout from '@/layout'

const children = [{
  path: 'my-schedule',
  name: 'MySchedule',
  component: () => import('@/views/MyCourse/MySchedule'),
  meta: { title: '我的课表' }
},
{
  path: 'MyHomeWork',
  name: 'MyHomeWork',
  component: () => import('@/views/MyCourse/homeWork'),
  meta: { title: '作业上传' }
},
{
  path: 'courseDetail',
  name: 'CourseDetail',
  component: () => import('@/views/MyCourse/courseDetail'),
  meta: { title: '课程详情', hidden: true, isShowSidebar: false }
},
{
  path: 'schedule-detail',
  name: 'ScheduleDetail',
  component: () => import('@/views/MyCourse/ScheduleDetail'),
  meta: { title: '学习详情', hidden: true, isShowSidebar: false }
},
{
  path: 'training-plan',
  name: 'TrainingPlan',
  component: () => import('@/views/MyCourse/TrainingPlan'),
  meta: { title: '培养计划', hidden: true }
},
{
  path: 'my-certificate',
  name: 'MyCertificate',
  component: () => import('@/views/MyCourse/myCertificate.vue'),
  meta: { title: '我的证书' }
}

]

// if (UserType === 'mba') {
//   const plan = {
//     path: 'training-plan',
//     name: 'TrainingPlan',
//     component: () => import('@/views/MyCourse/TrainingPlan'),
//     meta: { title: '培养计划' }
//   }
//   children.splice(1, 0, plan)
// }

const myCourse = {
  path: '/my-course',
  component: Layout,
  redirect: '/my-course/my-schedule',
  title: '我的课程',
  name: 'MyCourse',
  meta: { title: '我的课程', name: 'MyCourse' },
  children
}

export default myCourse
